import ArrowRight from "@/assets/Icons/arrowRight";
import { useGetAnnoncement } from "@/components/parts/admin/website-management/announcement/api";
import CardAnnoun from "@/components/parts/landing/announ/cardAnnoun";
import Link from "next/link";

const AnnounSection = () => {
  const { data } = useGetAnnoncement("limit=2");
  const detail = data?.data.items;
  return (
    <div className="container mx-auto flex flex-col md:flex-row gap-5 items-center py-10">
      <div className="flex flex-col gap-5 w-full md:w-[50%]">
        <div className="text-xl md:text-2xl font-semibold">Pengumuman</div>
        <div className="text-[#70707B] text-justify text-sm md:text-base">
          Berikut adalah informasi resmi yang disampaikan oleh Dinas Pertanian
          Kabupaten PALI terkait program, kegiatan, dan kebijakan di bidang
          pertanian yang perlu diketahui oleh para petani, penyuluh, dan
          masyarakat di wilayah Kabupaten PALI.
        </div>
        <div className="w-full md:w-fit">
          <Link
            href="/announcement"
            className="bg-primary w-full md:w-fit border p-2.5 px-4 hover:bg-primary-600 rounded-full text-center flex justify-center items-center gap-2 text-white text-sm md:text-base"
          >
            Lihat Selengkapnya
            <ArrowRight />
          </Link>
        </div>
      </div>
      {/*  */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
        {detail?.map((item, index) => (
          <CardAnnoun
            key={index}
            date={item.date}
            unduh={item.files ?? ""}
            title={item.title}
            description={item.content}
            image={item.image}
            href={`/announcement/${item.id}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AnnounSection;
